import type { PaymentMethodOnFile } from '@openeducation/pp-rn-shared-types';
import { atom } from 'jotai';

export const paymentMethodOnFileAtom = atom<PaymentMethodOnFile | null>(null);
